function errorInit() {
  // add custom error information to input
  const addToCartButton = document.querySelector(
    '.single-product .single_add_to_cart_button',
  );
  const input = document.querySelector('.input-number-quantity');
  const customTooltip = document.querySelector('.custom-info-tooltip');
  // check max input
  const max = input.getAttribute('max');
  if (max) {
    const showTooltip = () => {
      customTooltip.querySelector(
        'span',
      ).innerHTML = `For orders larger than ${max} please click here to <a href="#wpcf7-f1022-o1">contact us</a>`;
      customTooltip.style.display = 'block';
    };

    const hideTooltip = () => {
      customTooltip.style.display = 'none';
    };

    input.addEventListener('invalid', (event) => event.preventDefault());

    input.addEventListener('input', () => {
      // eslint-disable-next-line radix
      if (parseInt(input.value) > max) {
        showTooltip();
      } else {
        hideTooltip();
      }
    });

    addToCartButton.addEventListener('click', (event) => {
      // eslint-disable-next-line radix
      if (parseInt(input.value) > max) {
        event.preventDefault();
        showTooltip();
      } else {
        hideTooltip();
      }
    });

    document.addEventListener('click', (event) => {
      if (
        !customTooltip.contains(event.target) &&
        !event.target.classList.contains('single_add_to_cart_button')
      ) {
        hideTooltip();
      }
    });
  }
}

export default { errorInit };
